@if (!isVideo) {
  <img [src]="slide.image_url" class="card-img-top embed-responsive-item" alt="...">
}
@if (isVideo) {
  <iframe width="100%" height="100%" [src]="video_url | safe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
}
